import React from 'react';
import { EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import { WarningCard } from '../../cards/WarningCard';
import { LicensesCard } from '../../cards/LicensesCard';
import { UserProfileCard } from '../../cards/UserProfileCard';
import { OrganizationCard } from '../../cards/OrganizationCard';
import { RTLOwnershipCard } from '../../cards/OwnershipCard';

export const UserPage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <WarningCard />
        <Grid item xs={12} md={6}>
          <UserProfileCard />
        </Grid>
        {/* Beside the profile, which leaves the teams to it: who the person
            is and where they sit, side by side. Brings its own grid item: the
            card hides itself when the org tree says nothing about this person,
            and the ownership card then moves up into its place. */}
        <OrganizationCard />
        <Grid item xs={12} md={6}>
          <RTLOwnershipCard />
        </Grid>
        <Grid item xs={12} md={12}>
          <LicensesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
